import React, {
  useContext, useEffect, useRef, useState
} from 'react';
import { toast } from 'react-toastify';
import {
  FaArrowLeft, FaArrowRight,
  FaTrash, FaWhatsapp
} from "react-icons/fa";
import { useNavigate } from 'react-router-dom';

import {
  Container, InputsContainer, Label,
  Option, Select, SubContainer,
  SelectWrapper, DiaDaSemanaContainer,
  DetalhesContainer, Contato,
  OpcoesMenu
} from './styles';

import FormInput from '../../components/FormInput';
import Button from '../../components/Button';

import api from '../../services/api';
import Context, { IContext } from '../../context/Context';
import { IProfissional } from '../../types/Profissional';
import { IAgendamento } from '../../types/Agendamento';
import { IComFix } from '../../types/ComFix';
import { tratarData } from '../../utils/tratarData';



export default function Controle() {
  const navigate = useNavigate();
  const { setIsLoadingOverlay }: IContext = useContext(Context);
  const inputDataRef = useRef<HTMLInputElement>(null);

  const [abaSelecionada, setAbaSelecionada] = useState<'agenda' | 'compromissos'>('agenda');
  const [dat, setDat] = useState(new Date().toISOString().split('T')[0]);
  const [diaDaSemana, setDiaDaSemana] = useState(new Date().toISOString().split('T')[0]);
  const [profissional, setProfissional] = useState<IProfissional[]>([]);
  const [agendamentos, setAgendamentos] = useState<IAgendamento[]>([]);
  const [compromissosFixos, setCompromissosFixos] = useState<IComFix[]>([]);
  const [profissionalSelecionado, setProfissionalSelecionado] = useState('0');
  const [tipoSelecionado, setTipoSelecionado] = useState('');

  async function getData() {
    try {
      setIsLoadingOverlay(true);

      const [profissionaisResponse] = await Promise.all([
        api.get('/profissionais')
      ])

      if (profissionaisResponse.status === 200) {
        setProfissional(profissionaisResponse.data);
      }

    } catch (error) {
      toast.error('Erro ao buscar dados');
    } finally {
      setTimeout(() => {
        setIsLoadingOverlay(false);
      }, 500);
    }
  }

  async function getAgendamentos(data: string) {
    try {
      setIsLoadingOverlay(true);

      const response = await api.get('/agendamentos', {
        params: {
          dat: data,
          ...(profissionalSelecionado && profissionalSelecionado !== '0' && { codpro: profissionalSelecionado })
        }
      })

      if (response.status === 200) {
        if (response.data.length > 1) {
          const agendamentoOrdenadosPorHora = response.data.sort((a: IAgendamento, b: IAgendamento) => {
            return a.horini.localeCompare(b.horini);
          });

          setAgendamentos(agendamentoOrdenadosPorHora);
          return;
        }

        setAgendamentos(response.data);
      }

    } catch (error) {
      toast.error('Erro ao buscar agendamentos');
    } finally {
      setTimeout(() => {
        setIsLoadingOverlay(false);
      }, 500);
    }
  }


  async function deleteAgendamento(cod?: string | number) {
    try {
      if (!cod) return;
      setIsLoadingOverlay(true);

      await api.delete('/agendamentos/' + cod);
      setAgendamentos(agendamentos.filter(agendamento => agendamento.cod !== cod));

    } catch (error) {
      toast.error('Erro ao deletar agendamento');
    } finally {
      setTimeout(() => {
        setIsLoadingOverlay(false);
      }, 500);
    }
  }

  async function getCompromissosFixos(data: string) {
    try {
      setIsLoadingOverlay(true);

      const diaDaSemanaTratado = new Date(new Date(data).setHours(new Date(data).getHours() + 3)).toLocaleDateString('pt-BR', { weekday: 'long' });
      const diasem = diaDaSemanaTratado.split('-')[0];

      const response = await api.get('/compromissosFixos', {
        params: {
          datati: data,
          diasem: diasem[0].toUpperCase() + diasem.slice(1).normalize('NFD').replace(/[\u0300-\u036f]/g, ''),
          ...(tipoSelecionado && { tipent: tipoSelecionado })
        }
      })

      if (response.status === 200) {
        if (response.data.length > 1) {
          const compromissosOrdenadosPorHora = response.data.sort((a: IAgendamento, b: IAgendamento) => {
            return a.horini.localeCompare(b.horini);
          });

          setCompromissosFixos(compromissosOrdenadosPorHora);
          return;
        }

        setCompromissosFixos(response.data);
      }

    } catch (error) {
      toast.error('Erro ao buscar compromissos fixos');
    } finally {
      setTimeout(() => {
        setIsLoadingOverlay(false);
      }, 500);
    }
  }

  async function deleteCompromissoFixo(cod?: string | number) {
    try {
      if (!cod) return;
      setIsLoadingOverlay(true);

      await api.delete('/compromissosFixos/' + cod);
      setCompromissosFixos(compromissosFixos.filter(compromisso => compromisso.cod !== cod));

    } catch (error) {
      toast.error('Erro ao deletar compromisso');
    } finally {
      setTimeout(() => {
        setIsLoadingOverlay(false);
      }, 500);
    }
  }

  function voltarDia() {
    const diaAnterior = new Date(new Date(dat).setDate(new Date(dat).getDate() - 1)).toISOString().split('T')[0];
    setDat(diaAnterior);
    setDiaDaSemana(diaAnterior);
    getAgendamentos(diaAnterior);
    getCompromissosFixos(diaAnterior);
  }

  function proximoDia() {
    const diaPosterior = new Date(new Date(dat).setDate(new Date(dat).getDate() + 1)).toISOString().split('T')[0];
    setDat(diaPosterior);
    setDiaDaSemana(diaPosterior);
    getAgendamentos(diaPosterior);
    getCompromissosFixos(diaPosterior);
  }

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    getAgendamentos(dat);
  }, [profissionalSelecionado]);

  useEffect(() => {
    getCompromissosFixos(dat);
  }, [tipoSelecionado]);

  return (
    <Container>
      <Button
        translate='no'
        onClick={() => abaSelecionada === 'agenda' ? navigate('/') : navigate('/agendarCompromisso')}
        style={{ marginTop: '10px', minWidth: '15%', width: 'auto', alignSelf: 'center', backgroundColor: 'green'}}
      >
        {abaSelecionada === 'agenda' ? 'Novo Agendamento' : 'Novo Compromisso Fixo'}
      </Button>
      <OpcoesMenu>
        <h2
          translate="no"
          onClick={() => setAbaSelecionada('agenda')}
          className={abaSelecionada === 'agenda' ? 'ativo' : ''}
        >
          Agenda
        </h2>
        <h2
          translate="no"
          onClick={() => setAbaSelecionada('compromissos')}
          className={abaSelecionada === 'compromissos' ? 'ativo' : ''}
        >
          Compromissos
        </h2>
      </OpcoesMenu>
      <SubContainer>
        <DiaDaSemanaContainer>
          <FaArrowLeft
            size={35}
            onClick={() => voltarDia()}
          />
          <h3 translate='no'>
            {new Date(new Date(diaDaSemana).setHours(new Date(diaDaSemana).getHours() + 3)).toLocaleDateString('pt-BR', { weekday: 'long' })}
          </h3>
          <FaArrowRight
            size={35}
            onClick={() => proximoDia()}
          />
        </DiaDaSemanaContainer>
        <InputsContainer>
          <FormInput
            ref={inputDataRef}
            placeHolder=''
            type='date'
            required
            maxLength={14}
            onChange={e => {
              if (isNaN(new Date(e.target.value).getTime())) {
                setDat(new Date().toISOString().split('T')[0]);
                return;
              }

              setDat(e.target.value);
              setDiaDaSemana(e.target.value);
              getAgendamentos(e.target.value);
              getCompromissosFixos(e.target.value);
            }}
            onKeyDown={(e) => e.preventDefault()} // Previne digitação manual
            value={dat}
            onClick={() => inputDataRef?.current && inputDataRef.current.showPicker()}
          />
        </InputsContainer>
        {abaSelecionada === 'agenda' &&
          <SelectWrapper>
            <Label translate='no'>Professor(a):</Label>
            <Select value={profissionalSelecionado} onChange={e => setProfissionalSelecionado(e.target.value)}>
              <Option value='0' translate='no'>Qualquer Professor</Option>
              {profissional.map(profissional => (
                <Option key={profissional.cod} value={profissional.cod} translate='no'>{profissional.pro}</Option>
              ))}
            </Select>
          </SelectWrapper>}
        {abaSelecionada === 'compromissos' &&
          <SelectWrapper>
            <Label translate='no'>Tipo:</Label>
            <Select value={tipoSelecionado} onChange={e => setTipoSelecionado(e.target.value)}>
              <Option value='' translate='no'>Qualquer Tipo</Option>
              <Option value='Profissional' translate='no'>Professor</Option>
              <Option value='Espaco' translate='no'>Espaco</Option>
            </Select>
          </SelectWrapper>}
        {(abaSelecionada === 'agenda' && agendamentos.length > 0) && agendamentos.map((agendamento, index) => (
          <DetalhesContainer key={index}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span />
              <h3 translate='no'>{agendamento.horini} - {agendamento.profissional}</h3>
              <FaTrash
                style={{ cursor: 'pointer', textAlign: 'center', color: '#000', margin: '4px 4px -5px 0px' }}
                size={15}
                onClick={() => {
                  if (confirm(`Confirmar cancelamento ${agendamento.horini} - ${agendamento.profissional}?`)) {
                    deleteAgendamento(agendamento.cod);
                  }
                }}
              />
            </div>
            <p translate='no'>Aluno: {agendamento.nome}</p>
            <p translate='no'>Tipo de Aula: {agendamento.servico}</p>
            <p translate='no'>Ritmo: {agendamento.subservico}</p>
            <Contato>
              <p translate='no'>Contato: {agendamento.cel}</p>
              <FaWhatsapp
                onClick={() => window.open(`https://wa.me/55${agendamento.cel.replace(/\D/g, '')}`, '_blank')}
                size={20}
                style={{ cursor: 'pointer', color: '#25D366', marginLeft: '5px' }}
              />
            </Contato>
          </DetalhesContainer>
        ))}
        {(abaSelecionada === 'compromissos' && compromissosFixos.length > 0) && compromissosFixos.map((compromisso, index) => (
          <DetalhesContainer key={index}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span />
              <h3 translate='no'>{compromisso.horini.slice(0, 5)} - {(compromisso?.profissional || compromisso?.espaco) || 'Não encontrado'}</h3>
              <FaTrash
                style={{ cursor: 'pointer', textAlign: 'center', color: '#000', margin: '4px 4px -5px 0px' }}
                size={15}
                onClick={() => {
                  if (confirm(`Confirmar cancelamento ${compromisso.horini.slice(0, 5)} - ${compromisso.codent}?`)) {
                    deleteCompromissoFixo(compromisso.cod);
                  }
                }}
              />
            </div>
            <p translate='no'>Código: {compromisso.cod}</p>
            <p translate='no'>Dia da Semana: {compromisso.diasem}</p>
            <p translate='no'>Horário: {compromisso.horini.slice(0, 5)} - {compromisso.horfin}</p>
            <p translate='no'>Período: {tratarData(compromisso.datini)} - {tratarData(compromisso.datfin)}</p>
            <p translate='no'>Obs: {compromisso.obs}</p>
          </DetalhesContainer>
        ))}
        {(abaSelecionada === 'agenda' && agendamentos.length === 0 || abaSelecionada === 'compromissos' && compromissosFixos.length === 0) &&
          <h3 translate='no'>Nenhuma informação foi encontrada para o filtro informado.</h3>}
      </SubContainer>
    </Container >
  );
}
